<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout column>
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                <v-card-text>
                  <h3 style="text-align: left;margin-bottom: 10px">Overview Manifest</h3>
                  <v-divider divider: true></v-divider>
                  <v-flex xs6 child-flex>
                      <v-layout row wrap style="margin-top:10px;margin-left:20px">
                        <v-text-field
                          label="Enter Wynum Booking Number"
                        ></v-text-field>
                        <v-btn class="primary" flat style="margin-top:10px;">Submit</v-btn>
                      </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">Wynum Booking No.</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px">AME/FF/2563987</p>
                            <p style="text-align: left">Booking On : </p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">SL Booking No.</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px">AME/FF/2563987</p>
                            <p style="text-align: left">Booking On : </p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">Sales Order No.</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px">AME/FF/2563987</p>
                            <p style="text-align: left">Booking On : </p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">Reference No.</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px">AME/FF/2563987</p>
                            <p style="text-align: left">Booking On : </p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">Packing List Status</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px"><a href="">View PDF</a></p>
                            <p style="text-align: left">Booking On : </p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">Shipping Instruction Status</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px"><a href="">View PDF</a></p>
                            <p style="text-align: left">Booking On : </p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">Manifest Copy Status</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px"><a href="">View PDF</a></p>
                            <p style="text-align: left">Booking On : </p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">Vessel Cut Off Date</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px;margin-bottom: 50px">Date</p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">Port Shuttling Date</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px;margin-bottom: 50px">Date</p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">Export Custom Clearance</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px">ECS successfully completed on</p>
                            <p style="text-align: left">Date</p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">Departure Date</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px;margin-bottom: 50px">Date</p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">Arrival Notice Status</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px"><a href="">View PDF</a></p>
                            <p style="text-align: left">Received On:</p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">Arrival Date</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px;margin-bottom: 50px">Date</p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">Import Custom Clearance</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px">ICC successfully completed on</p>
                            <p style="text-align: left">Date</p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">Port of Loading</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px;margin-bottom: 50px">Saudi Arabia</p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs3 child-flex>
                        <v-card style="margin-top:20px;margin-left:20px">
                          <v-card-text>
                            <h3 style="text-align: left;margin-bottom: 10px">Port of Discharge</h3>
                            <v-divider divider: true></v-divider>
                            <p style="text-align: left;margin-top:10px;margin-bottom:50px">India</p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <h3 style="text-align: left;margin-bottom: 10px;margin-top:20px;margin-left: 20px">Action Tabs</h3>
                    <v-divider divider: true></v-divider>
                    <v-layout row wrap>
                      <v-btn class="primary" flat style="margin-top:10px;margin-left: 20px">Download PDF</v-btn>
                      <v-btn class="primary" flat style="margin-top:10px;margin-left: 20px">Print</v-btn>
                    </v-layout>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  mounted () {
    console.log('wynumtrack page')
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// src/components/Overviewmanifest.vue